import Index from '@/views/common/Index'
import IndexWeb from '@/views/common/IndexWeb'
import Home from '@/views/home/Home'

export default [
  {
    path: '/',
    name: 'login',
    component: resolve => require(['@/views/common/Login'], resolve)
  },
  {
    path: '/loginNoPage',
    name: 'LoginNoPage',
    component: resolve => require(['@/views/common/loginNoPage'], resolve),
  },
  {
    path: '/index',
    name: 'index',
    redirect: 'home',
    meta: {auth: true},
    component: Index,
    children: [
      //----------首页----------
      {
        path: '/home',
        meta: {auth: true, title: "首页"},
        component: Home,
        children: [{
            path: '/',
            name: 'home',
            component: resolve => require(['@/views/home/HomeList'], resolve)
          },{
            path: '/home/user',
            name: 'home/user',
            component: resolve => require(['@/views/home/HomeUser'], resolve)
          },

        ],
      },
    ]
  },
  {
    path: '/homeBig',
    name: 'homeBig',
    meta: {auth: true},
    component: resolve => require(['@/views/home/homeBig'], resolve),
  },
  {
    path: '/indexWeb',
    name: 'indexWeb',
    meta: {auth: true},
    component: IndexWeb,
  },
  {
    path: '/pdfViewer',
    name: 'pdfViewer',
    meta: {auth: true},
    component: resolve => require(['@/views/common/PdfViewer'], resolve),
  }
]



// WEBPACK FOOTER //
// ./src/router/home.js